import { useNavigate, useParams } from "react-router-dom";
import { Header } from "@/components/Header";
import { ProjectDetails as ProjectDetailsComponent } from "@/components/ProjectDetails";

const ProjectDetailsPage = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return (
      <div className="min-h-screen bg-background">
        <Header
          onNewProject={() => navigate("/new-project")}
          onViewProjects={() => navigate("/projects")}
        />

        <main className="container mx-auto px-4 py-6">
          <div className="p-6">
            <p className="text-muted-foreground">Project ID not found</p>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <Header
        onNewProject={() => navigate("/new-project")}
        onViewProjects={() => navigate("/projects")}
      />

      <main className="container mx-auto px-4 py-6">
        <ProjectDetailsComponent projectId={id} onBack={() => navigate("/projects")} />
      </main>
    </div>
  );
};

export default ProjectDetailsPage;
